<template>
  <template v-for="(option, index) in options" :key="option[valueKey] || index">
    <Card
      :id="option[valueKey] || index"
      class="grid-x margin-bottom-s"
      padding-class="padding-s"
      role="radio"
      :class="$attrs?.class"
      :tabindex="options.length > 1 ? '0' : undefined"
      :outlined="modelValue === (option[valueKey] || option)"
      @click="clickHandler(option, $event)"
      @keypress.enter="clickHandler(option, $event)"
    >
      <div v-if="options.length > 1 || (options.length === 1 && showRadio)" class="padding-right-xs flex-container align-middle align-center">
        <!-- eslint-disable-next-line vuejs-accessibility/form-control-has-label -->
        <input
          type="radio"
          tabindex="-1"
          :name="valueKey"
          :value="option[valueKey] || option"
          :checked="modelValue === option[valueKey] || modelValue === option"
        />
      </div>
      <div class="cell auto" :class="contentClass">
        <slot :option="option"></slot>
      </div>
    </Card>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <p v-if="option.message" class="gray-1-color margin-bottom-s" tabindex="0" v-html="option.message"></p>
  </template>
</template>

<script setup>
import Card from '@nuxt-common/atomic-ui/app/components/card/Card.vue';

// Define props
const props = defineProps({
  modelValue: {
    type: [String, Number, Object],
    required: true,
  },
  options: {
    type: Array,
    default: () => [],
  },
  valueKey: {
    type: String,
    default: 'id',
  },
  contentClass: {
    type: String,
    default: '',
  },
  showRadio: {
    type: Boolean,
    default: false,
  },
});

// Emit events
const emit = defineEmits(['update:modelValue']);

// Methods
const clickHandler = (option, event) => {
  emit('update:modelValue', option[props.valueKey] || option, event);
};
</script>

<style lang="scss" brand="mcom">
.card {
  border-radius: rem-calc(5);
}
</style>

<style lang="scss" brand="bcom">
.card {
  border-radius: rem-calc(0);
}
</style>

<style lang="scss" scoped>
.card {
  cursor: pointer;
  input {
    margin: 0;
  }
}
</style>
